import React, { useState, useEffect } from "react";
import { UseFormRegister } from "react-hook-form";

import { SwitchComponent } from "components";

type HookFormSwitchProps = {
	register: UseFormRegister<any>;
	setValue: Function;
	name: string;
	label?: string;
	isDisabled?: boolean;
	initialValue?: boolean;
	className?: string;
	onChange?: Function;
};

const HookFormSwitch = ({
	register,
	name,
	setValue,
	isDisabled = false,
	initialValue,
	label,
	className,
	onChange,
}: HookFormSwitchProps) => {
	const [enabled, setEnabled] = useState(initialValue || false);

	useEffect(() => {
		if (initialValue !== undefined) setEnabled(initialValue);
	}, [initialValue]);

	const handleChange = value => {
		setValue(name, value, { shouldDirty: true });
		setEnabled(value);
	};

	return (
		<div className={className}>
			<SwitchComponent
				enabled={enabled}
				onChange={v => {
					handleChange(v);
					onChange?.(v);
				}}
				disabled={isDisabled}
				label={label}
			/>
			<input {...register(name)} type="checkbox" hidden />
		</div>
	);
};

export default HookFormSwitch;
